var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('Header'),_c('OnGoing'),_c('InComing'),_c('div',{staticClass:"bottom-logo"}),_c('QrcodeDialog',{ref:"qrcode"}),_c('LinkDialog',{ref:"link"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }